import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithReauth,
  createBaseQueryFn,
  MinimalStateWithAuthToken, // Ensure this is exported from baseQuerySetup if used directly elsewhere
  tagTypes,
} from "./baseQuerySetup"; // Import from the new setup file

// Create and export API slices
export const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: baseQueryWithReauth,
  tagTypes,
  endpoints: () => ({}),
});

const imageApiBaseQuery = createBaseQueryFn(process.env.REACT_APP_IMAGE_API_URL || "");

export const imageApiSlice = createApi({
  reducerPath: "imageApiSlice",
  baseQuery: imageApiBaseQuery,
  endpoints: () => ({}),
});

export const currencyApiSlice = createApi({
  reducerPath: "currencyApiSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://openexchangerates.org",
  }),
  endpoints: () => ({}),
});

export const ocrApiSlice = createApi({
  reducerPath: "ocrApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://ecoya-export-ai-api.ecoya.dev/",
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as MinimalStateWithAuthToken).auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      // Assuming i18n is initialized elsewhere and accessible or passed down if needed
      // headers.set("accept-language", i18n.language);
      return headers;
    },
    // timeout: QUERY_TIME_OUT, // QUERY_TIME_OUT is in baseQuerySetup
  }),
  endpoints: () => ({}),
});
